import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Header from '../../components/Elements/header/header';
import CustomTittle from '../../components/Elements/customTittle/customTittle';
import NavigatorBarSummary from './navigatorBarSummary/navigatorBarSummary';
import DataSummary from './DataSummary/dataSummary';
import VariantSummary from './VariantSummary/variantSummary';
import PaymentChoose from './Payment/paymentChoose';
import Installment from './Installment/installment';
import Contract from './contract/contract';
import StepsOfBuy from './navigatorBarSummary/stepsOfBuy/stepsOfBuy';
import NavigatorBar from '../chooseUserBuy/navigation/navigationBar/navigationBar';
import SummaryOrder from './summaryOrder/summaryOrder';
import "./summary.css"
import AwaitContractConfirm from './awaitContractConfirm/awaitContractConfirm';
import ApiService from '../../services/ApiService';
import EDSFooter from '../../components/EDSFooter';
import ChooseUserBuy from '../chooseUserBuy/chooseUserBuy';
import YoungContract from './contract/youngContract';
 
const   Summary = (props) => {
  const apiService = new ApiService();
  const history = useHistory();
  let [lvl, setLvl ] = useState("chooseUser")
  let [steps, setSteps] = useState(1);
  let [trackingId, setTrackigId] = useState("");
  let [progres, setProgres] = useState(0)
  let [choosenPaymentOption, setChoosenPaymentOption] = useState();
  let [paymentP24, setPaymentP24] = useState();
  let [choosenPaymentType, setChoosenPaymentType] = useState(); // data to payForm
  let [choosenPaymentFull, setChoosenPaymentFull] = useState(); ///getGroup
  let [productID, setProductID] = useState();
  let [dataTo, setDataTo] = useState();
  let [installment, setInstallment]= useState();
  let [discountFull, setFullDiscount] = useState([]) // promotionsSalesID data to promotionData
  let [listOfInstallment, setListOfInstallment] = useState([])
  let [validation, setValidation] = useState(true)
  let [varaintTitle, setVaraintTitle] = useState("");
  let [varainBillet, setVarainBillet] = useState("");
  let [varaintHint, setVariantHint] = useState("");
  let [entryFee, setEntryFee] = useState("");
  let [billet, setBillet] = useState(false);
  let [nip, setNip] = useState("");
  let [card, setCard] = useState("")
  const [wrapNavigator, setWrapNavigator] = useState(false);
  const [header, setHeader] = useState("/  PROCES ZAKUPU KURSU")
  let [navigator, setNavigator] = useState(1)
  const [choosenAmount, setChoosenAmount] = useState(0);
  const participantUsers =  localStorage.getItem('selectedPartipient');
  const users =  JSON.parse(localStorage.getItem('users'));
  let userIDCard = localStorage.getItem('usersID');
  let [discountList, setDiscountList]= useState([])
  let [termsContract, setTermsContract] = useState({
    terms:false,
    statuseContract:false,
    accept: false
  });
  let [promotionsSalesID, setPromotionsSalesID]=useState("")
  let [paymentMethodList, setPaymentMethodList]=useState(
    {
    apple:false,
    google:false,
    blik:false,
    debetCard: false,
    przelewy24: true,
    payPo:false}
)
  let [summary, setSummary]= useState({
    value:"",
    entryFee:"",
    discount:"",
    summary:""
  })
  const userIDD = localStorage.getItem('participantUsersID')

let amount = 0;

useEffect(()=>{
  if(choosenPaymentOption == 6){
  const payload = { usersID: userIDCard, current_LocalizationsID: 0 };
        apiService.apiPost('getUserCards', payload, (response2) => {
            if (response2.success) {
           
              if(response2.data.length == 0){
                
              }else if(response2.data.length == 1){
                setCard(response2.data[0].paymentCardID)
              }else{
              response2.data.forEach((card)=>{
                if(card.defultCard){
                  setCard(card.paymentCardID)
                }
            
              })}
                // setCreditCards(response2.data);
            } else {
                // end(false);
            }
        });}
 
},[choosenPaymentOption])
useEffect(()=>{

  if(installment != undefined && listOfInstallment.length != 0){
    for(var i = 0; i < installment.paymentShedule.length; i++){
        
      if(i == 0||listOfInstallment.includes(installment.paymentShedule[i].countNumber))
      amount += installment.paymentShedule[i].paymentPositionPrice

      if(i == installment.paymentShedule.length - 1){
          if(installment.entryFee.priceDiscount != null){
          
          amount += installment.entryFee.priceDiscount}
          setChoosenAmount(amount.toFixed(2))
      }
  }

  }}, [listOfInstallment])


  let userID = localStorage.getItem('participantUsersID')
  let startingDate = localStorage.getItem('startingDate')
  const stepsIndex = 1;

  function nextLvlVariantSummary(arg, paymentType, paymentFull){

    localStorage.setItem("amount", arg)
    setChoosenPaymentFull(paymentFull)
setProductID(arg)
setChoosenPaymentType(paymentType)
nextLvl()
  }
  function nextLvl(arg){
    // if(arg != undefined){
    //   setChoosenPaymentOption(arg)}
    if(navigator != 8){
      let lvlValue = navigator + 1
     
      setNavigator(lvlValue)
    }
    if(progres != 4){
      let lvlValue = progres + 1
     
      setProgres(lvlValue)
    }
    if(lvl == "chooseUser"){
      setLvl("data")
   
    }else
    if(lvl == "data"){
      setLvl("variant")
   
    }else if(lvl == "variant"){
      setLvl("payment")
    }
    else if(lvl == "payment"){
      setLvl("installment")
    }
    
  }

  function prevLvl(){
  
    if(navigator != 8){
      let lvlValue = navigator - 1
     
      setNavigator(lvlValue)
    }
   
    if(progres != 0){
      let lvlValue = progres
      setProgres(lvlValue - 1)
      
    }
    
    if(steps == 1){
    if(lvl == "installment"){
      setLvl("payment")
    }else if(lvl == "payment"){
      setLvl("variant")
    }
    else if(lvl == "variant"){
      setLvl("data")
    } else if(lvl == "data"){
      setLvl("chooseUser")
    }}
    else if(steps == 2){
      setSteps(1)
    }


  }

  function nextSteps(){
    let stepsValue = steps

  
      // if(arg != undefined){
      //   setChoosenPaymentOption(arg)}
      if(navigator != 8){
        let lvlValue = navigator + 1
     
        setNavigator(lvlValue)
      }

    if(steps != 4){
      setSteps(stepsValue + 1)
 
    }
    // if(arg != undefined){
    // setChoosenPaymentOption(arg)}
  }
  function prevSteps(){
    let stepsValue = steps
    if(steps != 1){
      setSteps(stepsValue - 1)
    }
  }
  function confirmData(e){

    if(dataTo == undefined || dataTo.length == 0){
      setValidation(false)
    }else{
      setValidation(true)
      nextLvl()
    }
  }
  function navigatorClick(navi, level){
   
    setNavigator(navi);
    setLvl(level);
    

  }
  const stepsList = ["Rejestracja", "Kurs i formalności", "Podsumowanie"]
  function closeLogoutModal(e){
    e.preventDefault()
      let modalLogout = document.getElementById("modalLogout")
      modalLogout.classList.add("hidden")
  }
  function logout() {
    const key = localStorage.getItem('keyURL')
    localStorage.clear();
   
  

 history.push(`/LoginBuy/key=${key}`);
   
  }
  function moveToBillet(){
    console.log('aaaa')
    setBillet(true);
  }
  function moveToBilletPaySummary(){
    setSteps(5)
    setLvl('level');
  }
  function showModalLogout(){
    let modalLogout = document.getElementById("modalLogout")
    modalLogout.classList.remove("hidden")
  }

    return <> 
    <div className="modal hidden" id="modalLogout"><div className="modalContainer"><div className="closeButton">   <div className="closeButtonBox"><svg  onClick={(e)=>{closeLogoutModal(e)}} width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.39353 0.292893C1.78405 -0.0976311 2.41722 -0.0976311 2.80774 0.292893L14.8286 12.3137C15.2191 12.7042 15.2191 13.3374 14.8286 13.7279L14.5517 14.0048C14.1611 14.3953 13.528 14.3953 13.1374 14.0048L1.11662 1.98401C0.726099 1.59349 0.7261 0.960322 1.11662 0.569797L1.39353 0.292893Z" fill="#CC0033"></path><path d="M14.5519 0.292893C14.1614 -0.0976311 13.5282 -0.0976311 13.1377 0.292893L1.11685 12.3137C0.726329 12.7042 0.726329 13.3374 1.11685 13.7279L1.39376 14.0048C1.78428 14.3953 2.41745 14.3953 2.80797 14.0048L14.8288 1.98401C15.2193 1.59349 15.2193 0.960322 14.8288 0.569797L14.5519 0.292893Z" fill="#CC0033"></path></svg></div></div><div className="modalContent"><div className="logout_area"><p className="forAllTittle">Czy na pewno chcesz się wylogować?</p><div style={{height:"20px"}}></div><div className="row__buttons row"><button onClick={(e)=>{logout(e)}} className="forAll solid small">TAK</button>
              <button onClick={(e)=>{closeLogoutModal(e)}} className="forAll solid small">NIE</button></div></div></div></div></div>
<Header >{header}</Header>

<div className="content">
<div className='contentSummary_wrapper'>

        <div className='contentSummary_header'>
        {header == '/  PROCES ZAKUPU KURSU'?steps < 2?<div className='contentSummary_back' onClick={prevLvl}>
            <svg className="helloIconSVG" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path fill="rgba(204,0,51,1)" d="M11.62 3.81 7.43 8l4.19 4.19-1.53 1.52L4.38 8l5.71-5.71 1.53 1.52z"/></svg>
            <p className='helloEmail'>POWRÓT</p>
            </div>:<div className='space_contentSummary_back'></div>:"" }
            <div className='nav_container'> 
            <StepsOfBuy lvl={lvl} steps={navigator} choosen={stepsIndex} stepsList={stepsList}></StepsOfBuy>
            {navigator < 8?<NavigatorBar clickForSmalButton={prevLvl} wrapNavigator={wrapNavigator} steps={navigator}></NavigatorBar>:""}
            </div>
          
             {header == '/  PROCES ZAKUPU KURSU'?<div className='contentSummary_logout test' onClick={showModalLogout}>
              <svg className="helloIconSVG" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 22C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V6H18V4H6V20H18V18H20V21C20 21.5523 19.5523 22 19 22H5ZM18 16V13H11V11H18V8L23 12L18 16Z" fill="rgba(204,0,51,1)"></path></svg>
              <p className='helloEmail'>WYLOGUJ SIĘ</p>
            </div>:""
}  

        </div>
        
   
        {lvl == "chooseUser"?<ChooseUserBuy setTracking={setTrackigId} wrapNavigator={wrapNavigator} setWrapNavigator={setWrapNavigator} next={nextLvl} setHeader={setHeader} header={header} ></ChooseUserBuy>:""}
        {lvl == "data"?<DataSummary wrapNavigator={wrapNavigator} start={dataTo} setWrapNavigator={setWrapNavigator}  header={header} 
        setHeader={setHeader} setNavigator={navigatorClick} validation={validation} setData={setDataTo} next={confirmData} ></DataSummary>:""}
        {lvl == "variant"?<VariantSummary wrapNavigator={wrapNavigator} setWrapNavigator={setWrapNavigator}  header={header} setHeader={setHeader}
          setNavigator={navigatorClick} setVarainBillet={setVarainBillet} setFee={setEntryFee} start={dataTo}next={nextLvlVariantSummary} nextToBillet={moveToBillet} ></VariantSummary>:""}
        {lvl == "payment"?<PaymentChoose 
        promotionsSalesID={promotionsSalesID} isBillet={billet} nextToBillet={moveToBilletPaySummary} setPromotionsSalesID={setPromotionsSalesID} paymentMethodList={paymentMethodList} setPaymentMethodList={setPaymentMethodList}
        discountList={discountList} setDiscountList={setDiscountList} setPayP24={setPaymentP24} wrapNavigator={wrapNavigator} setWrapNavigator={setWrapNavigator}  header={header} setHeader={setHeader}
          paymentP24={paymentP24} setNavigator={navigatorClick} setNip={setNip} nip={nip}  discountD={discountFull} setTittle={setVaraintTitle} setHint={setVariantHint} start={dataTo} paymentMethod={choosenPaymentFull} discount={setFullDiscount} data={{productID:productID,choosenPaymentType:choosenPaymentType}}onChoose={(e)=>{setChoosenPaymentOption(e)}} choosenPayment={choosenPaymentOption} next={nextLvl} ></PaymentChoose>:""}
        {lvl == "installment"&&steps == 1?<Installment wrapNavigator={wrapNavigator} setWrapNavigator={setWrapNavigator}  header={header} setHeader={setHeader}
         setNavigator={navigatorClick} discountD={discountFull} installment={installment}  setInstallment={setInstallment} listOfInstallment={listOfInstallment} setFee={setEntryFee} setListOfInstallment={setListOfInstallment} data={{
         choosenPaymentOption:choosenPaymentOption,
         paymentP24:paymentP24,
         data:dataTo,
         productID:productID,
         promotionsSalesIDList:discountFull.promotionsSalesID,
         variantTittle: varaintTitle,
         varaintHint:varaintHint,
         entryFee:entryFee,
         nip:nip
        }}
        setSummary={setSummary} next={nextSteps} start={dataTo} ></Installment>:""}
        {/* {steps == 2&&!users?.adult?<YoungContract start={dataTo}  setNavigator={navigatorClick} wrapNavigator={wrapNavigator} setWrapNavigator={setWrapNavigator}  header={header} setHeader={setHeader}
        discountD={discountFull}
        data={{
          payForm:choosenPaymentType,
          paymentType:choosenPaymentOption,
          getGroup:choosenPaymentFull,
          promotionData:discountFull,
          summary:summary,
          entryFee:entryFee,
          installment:installment.paymentShedule,
         variantTittle: varaintTitle,
         listOfInstallment:listOfInstallment,
         choosenAmount:choosenPaymentFull.currentPrice,
         varaintHint:varaintHint}}></YoungContract>:""} */}
         {/* &&users?.adult \/ */}
        {steps == 2?
        <Contract  wrapNavigator={wrapNavigator} setWrapNavigator={setWrapNavigator}  header={header} setHeader={setHeader}
         condition={termsContract} setNavigator={navigatorClick} acceptCondition={setTermsContract} discountD={discountFull} next={nextSteps} start={dataTo} installment={installment} data={{
          payForm:choosenPaymentType,
          paymentType:choosenPaymentOption,
          getGroup:choosenPaymentFull,
          promotionData:discountFull,
          summary:summary,
          entryFee:entryFee,
          installment:installment.paymentShedule,
         variantTittle: varaintTitle,
         listOfInstallment:listOfInstallment,
         choosenAmount:choosenPaymentFull.currentPrice,
         varaintHint:varaintHint}}></Contract>:""}
        {steps == 3?<AwaitContractConfirm trackingId={trackingId} participantUsers={JSON.parse(participantUsers)} wrapNavigator={wrapNavigator} setWrapNavigator={setWrapNavigator}  header={header} setHeader={setHeader}
         condition={termsContract} setNavigator={navigatorClick} acceptCondition={setTermsContract} discountD={discountFull} start={dataTo} installment={installment} data={{
            nip:nip,
            card:card,
            entryFee:entryFee,
            summary:summary,
            paymentP24:paymentP24,
          variantTittle: varaintTitle,
          varaintHint:varaintHint,
          choosenPaymentOption:choosenPaymentOption,
          productID:productID,
          listOfInstallment:listOfInstallment,
          choosenAmount:choosenPaymentFull.currentPrice
        }} next={nextSteps} ></AwaitContractConfirm>:""}
        {steps == 4?<SummaryOrder paymentP24={paymentP24} trackingId={trackingId} steps={true} wrapNavigator={wrapNavigator} setWrapNavigator={setWrapNavigator}  header={header} setHeader={setHeader}
         discountD={discountFull} start={dataTo}  setNavigator={navigatorClick}
         installment={installment}
         data={{
          variantTittle: varaintTitle,
          listOfInstallment:listOfInstallment,
          varaintHint:varaintHint,
          entryFee:entryFee,
          choosenAmount:choosenPaymentFull.currentPrice,
          choosenPaymentOption:choosenPaymentOption,
          installment:installment.paymentShedule,
        }}></SummaryOrder>:""}
        {steps == 5?<SummaryOrder paymentP24={paymentP24} trackingId={trackingId} steps={true} wrapNavigator={wrapNavigator} setWrapNavigator={setWrapNavigator}  header={header} setHeader={setHeader}
         discountD={discountFull} start={dataTo}  setNavigator={navigatorClick}
         installment={installment}
         isBillet={true}
         data={{
          variantBillet:varainBillet,
          variantTittle: varaintTitle,
          listOfInstallment:listOfInstallment,
          varaintHint:varaintHint,
          entryFee:entryFee,
          choosenAmount:choosenPaymentFull.currentPrice,
          choosenPaymentOption:choosenPaymentOption,
          // installment:installment.paymentShedule,
        }}></SummaryOrder>:""}
</div></div>

    </>;
    }

export default Summary;
